// @flow

const styles = {
  preCtr: (theme) => ({
    ...theme.typography.body1,
    padding: '8px 16px'
  }),
  content: (theme) => ({
    flexGrow: 1,
    padding: theme.spacing(3)
  }),
  contentTitle: (theme) => ({
    marginTop: 40
  }),
  toolbar: (theme) => theme.layout.customProps.toolbar,

  requestPreviewCtrMobile: (theme) => ({
    [theme.breakpoints.down('sm')]: {
      position: 'sticky',
      backgroundColor: 'white',
      top: theme.layout.customProps.header.height*2,
      zIndex: 99,
      marginTop: -theme.spacing(1),
      width: '100%',
      maxWidth: '100%',
      marginBottom: theme.spacing(2),
      marginLeft: 0,
      marginRight: 0,
      overflowX: 'hidden'
    }
  }),
  requestContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    position: 'relative',
    overflow: 'hidden'
  }),
  tableRequestContent: (theme) => ({
    padding: 0,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 0,
    marginRight: 0,
    height: `calc(100vh - ${theme.layout.customProps.header.height * 2}px)`,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100vw',
      overflowX: 'hidden',
      padding: 0,
      height: `calc(100vh - ${theme.layout.customProps.header.height}px)`
    }
  }),
  requestPreviewCtr: (theme) => ({
    position: 'sticky',
    backgroundColor: 'white',
    top: theme.layout.customProps.header.height*2,
    zIndex: 99,
    marginTop: -theme.spacing(4),
    marginBottom: theme.spacing(3),
    marginLeft: 0,
    marginRight: 0,
    width: `calc(100vw - ${theme.layout.customProps.drawer.width}px - ${theme.spacing(8)})`,
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingTop: theme.spacing(1)
  }),
  listRoot: (theme) => ({
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.down('sm')]: {
      borderRadius: theme.shape.borderRadius / 2
    }
  }),
  chatListRootCtr: (theme) => ({
    width: '100%'
  }),
  chatListRoot: (theme) => ({
    marginTop: theme.spacing(1),
    marginBottom: 30,
    width: '100%'
  }),
  listItem: (theme) => ({
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0
    }
  }),
  noLeftPadding: (theme) => ({
    paddingLeft: 0
  }),
  requestHistoryEntryTitle: (theme) => ({
    position: 'relative',
    fontSize: '0.9rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.875rem',
      maxWidth: 'calc(100vw - 120px)'
    }
  }),
  requestHistoryEntryCtr: (theme) => ({
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      paddingLeft: theme.spacing(2)
    }
  }),
  historyEntrySummary: (theme) => ({
    paddingTop: 0,
    paddingBottom: 0,
    '&:hover .hover': {
      fontWeight: 700
    }
  }),
  historyEntrySummaryTitle: (theme) => ({
    minWidth: 100,
    display: 'inline-block'
  }),
  inline: (theme) => ({
    display: 'inline'
  }),
  expansionPanel: (theme) => ({
    marginTop: 0,
    marginBottom: 0,
    boxShadow: '0px 2px 8px -1px rgba(0,0,0,0.2)',
    [theme.breakpoints.down('sm')]: {
      '&:first-of-type': {
        borderTopLeftRadius: theme.shape.borderRadius / 2,
        borderTopRightRadius: theme.shape.borderRadius / 2
      },
      '&:last-child': {
        borderBottomRightRadius: theme.shape.borderRadius / 2,
        borderBottomLeftRadius: theme.shape.borderRadius / 2
      }
    }
  }),
  expansionPanelSummary: (theme) => ({
    position: 'relative',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    cursor: 'pointer',
    '& li': {
      width: '100%'
    },
    [theme.breakpoints.down('sm')]: {
      '& li:last-child': {
        paddingRight: 0
      }
    }
  }),
  expansionPanelSummaryRoot: (theme) => ({
    borderBottom: 0,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0
    }
  }),
  ExpansionPanelDetailsRoot: (theme) => ({
    paddingTop: 0,
    paddingBottom: 0,
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2)
    }
  }),
  requestHistoryTimestamp: (theme) => ({
    fontSize: '0.9rem',
    margin: '8px 12px',
    [theme.breakpoints.down('sm')]: {
      color: 'hsl(0,0%,66%)',
      fontSize: '0.8rem',
      margin: '0px 0 8px 0'
    }
  }),
  disabledExpansion: (theme) => ({
    cursor: 'default !important'
  }),
  beforeChat: (theme) => ({
    marginBottom: theme.spacing(2)
  }),
  chatListItem: (theme) => ({
    border: 0,
    backgroundColor: theme.layout.customProps.drawer.backgroundColor,
    borderRadius: 0,
    marginTop: -theme.spacing(1),
    marginBottom: -theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    whiteSpace: 'pre-wrap',
    '&.first': {
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      paddingTop: theme.spacing(2)
    },
    '&.last': {
      borderBottomLeftRadius: theme.shape.borderRadius,
      borderBottomRightRadius: theme.shape.borderRadius,
      paddingBottom: theme.spacing(2)
    },
    '& svg': {
      position: 'relative',
      top: 1
    },
    [theme.breakpoints.down('sm')]: {
      '&.first': {
        borderTopLeftRadius: theme.shape.borderRadius / 2,
        borderTopRightRadius: theme.shape.borderRadius / 2
      },
      '&.last': {
        borderBottomLeftRadius: theme.shape.borderRadius / 2,
        borderBottomRightRadius: theme.shape.borderRadius / 2
      }
    }
  }),
  statusIconsColors: (theme) => theme.props.statusIconsColors,
  historyItemTime: (theme) => ({
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8125rem',
      maxWidth: 50,
      marginRight: theme.spacing(1)
    }
  }),
  eventIcon: (theme) => ({
    color: theme.palette.primary.main
  }),
  hTitle: (theme) => ({
    fontSize: '0.9rem',
    fontWeight: 600,
    color: 'hsl(0,0%,45%)',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`
  }),
  listSecondaryActionCtr: (theme) => ({
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    right: 0,
    position: 'absolute',
    width: 'auto',
    marginRight: 40,
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      top: 0,
      display: 'block',
      transform: 'none',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    }
  }),
  attachmentRowCtr: (theme) => ({
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'hidden',
    overflowX: 'scroll',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    '& > div > img': {
      display: 'block',
      width: 150,
      minWidth: 150,
      height: 150
    }
  }),
  attachment: (theme) => ({
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(1),
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      borderRadius: theme.shape.borderRadius / 2
    }
  }),
  attachmentSmallCtr: (theme) => ({
    right: 0,
    top: -25,
    display: 'flex',
    alignContent: 'flex-end',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      top: 0,
      marginBottom: theme.spacing(1.5),
      marginLeft: -theme.spacing(2),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    }
  }),
  attachmentSmall: (theme) => ({
    width: '35px !important',
    height: '35px !important',
    borderRadius: 4,
    margin: '0px 2px',
    padding: 0
  }),
  unreadAnchorCtr: (theme) => ({
    position: 'fixed',
    bottom: 150,
    width: `calc(100vw - ${theme.layout.customProps.drawer.width} - ${theme.spacing(3)*2})`,
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  }),
  unreadAnchorPopperContent: (theme) => ({
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    margin: '0 auto'
  }),
  messagesArea: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflowY: 'auto',
    paddingBottom: '120px', // Space for reply box
    height: 'auto',
    position: 'relative',
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      maxWidth: '100%',
      overflowX: 'hidden',
      paddingBottom: '70px'
    }
  }),
  replyBox: (theme) => ({
    backgroundColor: 'white',
    position: 'fixed',
    bottom: 0,
    left: theme.layout.customProps.drawer.width,
    width: `calc(100vw - ${theme.layout.customProps.drawer.width}px - ${theme.spacing(4)})`,
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(1),
    boxShadow: '0px -2px 4px rgba(0,0,0,0.1)',
    borderRadius: theme.shape.borderRadius,
    zIndex: 100,
    [theme.breakpoints.down('sm')]: {
      left: 0,
      width: '100vw',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      boxSizing: 'border-box'
    }
  }),
  contentCtr: (theme) => ({
    marginBottom: '24px'
  })
};

export default styles;